import { render, staticRenderFns } from "./RatesSummary.vue?vue&type=template&id=6d550e1a&scoped=true"
import script from "./RatesSummary.vue?vue&type=script&lang=js"
export * from "./RatesSummary.vue?vue&type=script&lang=js"
import style0 from "./RatesSummary.vue?vue&type=style&index=0&id=6d550e1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d550e1a",
  null
  
)

export default component.exports